<template>
  <!--
          作者：luoyiming
          时间：2019-10-25
          描述：商户-提现管理
      -->
  <div class="user clearfix">
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="workerlist" border style="width: 100%" >
        <el-table-column type="index" label="">
          </el-table-column>
          <el-table-column prop="card_number" label="银行卡号/支付宝账号">
          </el-table-column>
          <el-table-column prop="card_address" label="开户地址">
          </el-table-column>
          <el-table-column prop="orderNo" label="提现单号">
          </el-table-column>
          <el-table-column prop="money" label="提现金额">
          </el-table-column>
          <el-table-column prop="status" label="提现状态">
             <template slot-scope="scope">
                  <span style="color: cadetblue" v-if="scope.row.status == 0">审核中</span>
                  <span style="color: green" v-else-if="scope.row.status == 1">已通过审核</span>
                  <span style="color: red" v-else>已拒绝</span>
              </template>
          </el-table-column>
          <el-table-column prop="type" label="提现方式">
             <template slot-scope="scope">
                  <span style="color: green" v-if="scope.row.type == 1">银行卡</span>
                  <span style="color: green" v-else-if="scope.row.type == 2">支付宝</span>
              </template>
          </el-table-column>
          <el-table-column prop="createTime" label="申请日期">
          </el-table-column>
           <el-table-column prop="card_name" label="开户行/支付宝姓名">
          </el-table-column>
          <el-table-column label="操作">
              <template slot-scope="scope">
                  <span style="color: #0f85f4; cursor: pointer;" @click="navchange(scope.row)">审核</span>
              </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="getworker.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="getworker.rows"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
      </div>
    </div>

    <!--审核-->
      <el-dialog
        title="审核"
        :visible.sync="dialogVisible"
        width="30%">
        <el-form :model="workerinfo" :rules="rules" ref="formName">
          
            <el-form-item label="是否允许" prop="radio">
                  <el-radio v-model="workerinfo.status" label="1">允许</el-radio>
                  <el-radio v-model="workerinfo.status" label="2">拒绝</el-radio>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="changestatus">确 定</el-button>
        </span>
      </el-dialog>
  </div>
</template>

<script>
  import SupplierApi from '@/api/supplier.js';
  import Submit from './dialog/Submit'
  import request from '@/utils/request'
  import {
    deepClone
  } from '@/utils/base'
  export default {
    components: {
      Submit
    },
    data() {
      return {
       rules: {
        status: [
            { required: true, message: '请选择！', trigger: 'blur' }
          ]
       },
        workerinfo: {
           status: 0,
        },
        dialogVisible: false,
        workerlist: [],
        getworker: {
            page: 1,
            rows: 10
        },
        total: 0
      };
    },
    created() {

      /*获取列表*/
      this.getTableList() 

    },
    mounted() {
      console.log('1212', this.workerlist);
    },
    methods: {
      // 进入审核页面
      navchange(e) {
        this.workerinfo.income_id = e.income_id
        this.dialogVisible = true
      },
      // 修改审核状态
      changestatus() {
            let that = this
            this.$refs['formName'].validate((valid) => {
              if (valid) {
                    request._post('/shop/waiter.income/replyIncome', {
                    income_id: that.workerinfo.income_id,
                    status: that.workerinfo.status
                  }).then(res=> {
                      if (res.code == 1) {
                        that.$message({
                          type: 'success',
                          message: res.msg 
                        });
                  }
                  that.getTableList()
            })
          }else{
            console.log('选择', that.workerinfo);
          }
        });
       
        this.dialogVisible = false
      },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.getworker.page = val
        this.getTableList()
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.getworker.rows = val
        this.getTableList()
      },

      /*获取列表*/
      getTableList() {
        let that = this;
        request._get('/shop/waiter.income/incomeStatusList', this.getworker).then(res => {
          console.log(res, 121);
          this.workerlist = res.data.data
          this.total = res.data.total
        })
       
      }

    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/supplier/supplier/cash.vue